import { useCurrentGym } from "../../../hooks/gym/useCurrentGym";

export const GymTaxInfo = () => {
  const { data: gym, isLoading } = useCurrentGym();

  const vat = gym?.taxesConfig.vat ?? null;
  const vatPercent = vat !== null ? Math.round(vat * 100) : null;

  return (
    <div className="space-y-1">
      <label className="text-label">IVA / VAT</label>
      <div className="card-section">
        {isLoading ? (
          <p className="text-size-sm text-global-tertiary italic">
            Cargando...
          </p>
        ) : vatPercent !== null ? (
          <p className="text-size-sm font-medium text-global-primary">
            {vatPercent}%
          </p>
        ) : (
          <p className="text-size-sm text-global-tertiary italic">
            No disponible
          </p>
        )}
      </div>
    </div>
  );
};
